export const IS_DEV = process.env.NODE_ENV !== 'production';
export const API_URL = process.env.API_URL;
export const PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL;
export const STRIPE_SECRET_KEY = process.env.STRIPE_SECRET_KEY;
export const PUBLIC_STRIPE_PUBLISHABLE_KEY = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
export const FILESTACK_API_KEY = process.env.NEXT_PUBLIC_FILESTACK_API_KEY;
export const PUBLIC_PAYPAL_CLIENT_ID = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID;


